import * as React from "react";
import { BusinessServiceDescriptor } from "../../BusinessServiseDescriptor";
import { zBom3Settings } from "./ZBom3Settings";
import { loadBom3Settings, saveBom3Settings } from "./apiBom3";
import { Bom3Settings } from "./Bom3Settings";
import { Bom3Control } from "./Bom3Control";

export const bsBom3: BusinessServiceDescriptor = {
  key: "BOM v3.0",
  viewer(info, data) {
    return <Bom3Control info={info} entityData={data} />;
  },
  renderSettings(info, store) {
    return (
      <Bom3Settings
        modelObjectId={info.objectId}
        typesMap={store.attrTypesDict}
        objList={store.treeData.filter((it) => it.type === "obj")}
      />
    );
  },
  async loadSettings(info) {
    return loadBom3Settings(info.objectId);
  },
  async saveSettings(info, values) {
    await saveBom3Settings(info.objectId, info.id, zBom3Settings.parse(values));
  },
};
